export const HEADER_NAMES = {
  xRequestId: 'x-request-id',
  /** Идентификатор текущего запроса */
  traceId: 'X-Trace-Id',
  /** Идентификатор сессии */
  sessionId: 'X-Session-Id',
  /** Идентификатор пользователя SravniId */
  ownerId: 'X-Owner-Id',
  /** Страница и контекст, с которой поступил запрос */
  pageContext: 'X-Page-Context',
  /** урл с которой сделан запрос */
  pageReferer: 'X-Page-Referer',
  /** Ip адрес отправителя */
  userIp: 'X-User-Fingerprint',
  /** Группы экспериментов пользователя в виде строки */
  abGroups: 'X-AB-Groups',
  preApprovalConfirmationRetryAfter: 'retry-after',
};
